import { render, staticRenderFns } from "./AlertDetails.html?vue&type=template&id=76c51c80&scoped=true&external"
import script from "./AlertDetails.vue?vue&type=script&lang=js"
export * from "./AlertDetails.vue?vue&type=script&lang=js"
import style0 from "./AlertDetails.scss?vue&type=style&index=0&id=76c51c80&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c51c80",
  null
  
)

export default component.exports